WiseMetering.Views.NewNetmoreIntegration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration',
    template: 'templates/integrations/netmore/new',
    title: () => i18next.t('modal.title.integrations.new'),
    ui: {
        indicatorKinds: '#integration_kind_slug',
        sites: '#integration_site_id'
    },

    afterSave: function() {
        WiseMetering.indicators.fetch();
    },

    onShow: function() {
        const
            indicatorKinds = WiseMetering.utils.optionsFromArray(WiseMetering.indicatorKinds.map(kind => ({
                id: kind.get('slug'),
                name: kind.get('name')
            }))),
            sites = WiseMetering.utils.optionsFromModels(WiseMetering.zones.activeSites().models, 'name');

        this.ui.indicatorKinds.html(indicatorKinds);
        this.ui.sites.html(sites);
    },

    getFormData: function() {
        const data = this.formSerializer();

        data.partner_id = this.options.license.get('partner_id');
        data.reference_rate = parseInt(data.reference_rate, 10);

        return data;
    }
});
